import { render, staticRenderFns } from "./FolderRelaunchDialog.vue?vue&type=template&id=772e2aa1&scoped=true"
import script from "./FolderRelaunchDialog.vue?vue&type=script&lang=js"
export * from "./FolderRelaunchDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderRelaunchDialog.vue?vue&type=style&index=0&id=772e2aa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e2aa1",
  null
  
)

export default component.exports